class MarketplaceFilter {
	constructor(form) {
		this.allFilter = form.querySelector('.js-filter-control[value="all"]');
		this.categoryFilters = [...form.querySelectorAll('.js-filter-control[value]:not([value="all"])')];
		this.teasers = document.querySelectorAll('.js-offer-teaser');

		if (this.allFilter) this.allFilter.checked = true;

		this.allFilter?.addEventListener('click', () => {
			if (!this.allFilter.checked) this.allFilter.checked = true;
		});

		this.allFilter?.addEventListener('change', () => {
			this.categoryFilters.forEach(f => f.checked = false);
			this.updateVisibility();
		});

		this.categoryFilters.forEach(f => f.addEventListener('change', () => {
			if (this.allFilter) this.allFilter.checked = false;
			if (this.categoryFilters.every(f => !f.checked) && this.allFilter) this.allFilter.checked = true;
			this.updateVisibility();
		}));
	}

	updateVisibility() {
		const activeIds = this.categoryFilters.filter(f => f.checked).map(f => f.value);

		this.teasers.forEach(teaser => {
			const item = teaser.closest('.js-offer-grid-item');
			if (!item) return;
			if (activeIds.length === 0) {
				item.hidden = false;
				return;
			}
			const teaserCats = teaser.dataset.offerCategories.split(',');
			item.hidden = !activeIds.some(id => teaserCats.includes(id));
		});
	}
}

export default MarketplaceFilter;
